import { useBreakpoints } from '@vueuse/core';

export const breakpoints = useBreakpoints({
  small: 780,
});
